import React, { useEffect, useState } from 'react'

import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { updateBestTeachingAwardParams } from '../../actions'
import axios from 'axios'
import moment from 'moment-timezone'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

const inseadCanvasAdminStorage =
  JSON.parse(localStorage.getItem('inseadCanvasAdmin')) || null

function StepOne(props) {
  const { onTabChange, onCourseTypeChange, onCampusChange } = props
  const [openingDate, setOpeningDate] = useState(null)
  const [value, setValue] = React.useState(props.data.setupIndex)
  const [campus, setCampus] = React.useState([])
  const [activeCampus, setActiveCampus] = React.useState('')
  const handleChange = (event, newValue) => {
    setValue(newValue)

    let type = ''
    type = newValue === 0 ? 'S' : 'Prof'

    const campus = type

    const dataSet = {
      setupIndex: newValue,
      campus,
      courseType: props.data.courseType
    }
    onTabChange(dataSet)
  }

  const handleCourseTypeChange = (event) => {
    const courseType = event.target.value

    const dataSet = {
      setupIndex: props.data.setupIndex,
      campus: props.data.campus,
      courseType
    }

    onCourseTypeChange(dataSet)
  }

  const handleCampusChange = (event) => {
    const campus = event.target.value

    const dataSet = {
      setupIndex: props.data.setupIndex,
      campus,
      courseType: props.data.courseType
    }
    setActiveCampus(campus)
    onCampusChange(dataSet)
  }

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/opening-date?user_name=${inseadCanvasAdminStorage.user.name}`
      )
      .then((response) => {
        setOpeningDate(response.data.data[0].opening_date)
      })
      .catch(() => {})
    axios
      .get(
        `${process.env.REACT_APP_BEST_TEACHING_BASE_URL_API}/best-teaching-reports/api/campus`,
        {
          params: {
            ...(inseadCanvasAdminStorage !== null
              ? {
                  user_id: inseadCanvasAdminStorage.user.name
                }
              : {})
          }
        }
      )
      .then((response) => {
        setCampus(response.data.data)
      })
      .catch((error) => {})
  }, [])

  return (
    <Paper
      style={{
        padding: '24px'
      }}
      square
    >
      <>
        <div
          style={{
            paddingLeft: '12px',
            display: 'flex',
            gap: '16px',
            justifyContent: 'flex-start',
            marginBottom: '16px'
          }}
        >
          <div>
            <Typography variant='subtitle2' component='p'>
              BTA Vote Opening Date
            </Typography>
          </div>
          <div>{moment(openingDate).format('DD MMM YYYY')}</div>
        </div>

        <Tabs
          value={value}
          indicatorColor='primary'
          textColor='primary'
          onChange={handleChange}
        >
          <Tab label='By Campus & Course' />
          <Tab label='By Professor' />
        </Tabs>

        <TabPanel value={value} index={0}>
          <FormControl fullWidth>
            {campus ? (
              <>
                <InputLabel id='demo-simple-select-label'>
                  Select Campus
                </InputLabel>
                <Select
                  value={props.data.campus}
                  label='Campus'
                  onChange={handleCampusChange}
                >
                  {
                    [
                      {
                        campus: "FBL"
                      },
                      {
                        campus: "SGP"
                      },
                      {
                        campus: "FBLSG"
                      },
                      {
                        campus: "ABD"
                      },
                    ].map((value) => (
                        <MenuItem value={Object.values(value)[0]}>
                          {Object.values(value)[0]}
                        </MenuItem>
                    ))
                  }
                </Select>
              </>
            ) : null}
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>
              Select Course Type
            </InputLabel>
            <Select
              value={activeCampus === 'FBLSG' ? 'elective' : props.data.courseType}
              label='Campus'
              onChange={handleCourseTypeChange}
            >
              {/*IF the user selects the value "FBLSG" from the picklist SELECT CAMPUS*/}
              <MenuItem value='elective'>Elective</MenuItem>
              <MenuItem disabled={activeCampus === 'FBLSG'} value='core'>
                Core
              </MenuItem>
            </Select>
          </FormControl>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <FormControl fullWidth>
            <InputLabel id='demo-simple-select-label'>
              Select Course Type
            </InputLabel>
            <Select
              value={props.data.courseType}
              label='Campus'
              onChange={handleCourseTypeChange}
            >
              <MenuItem value='elective'>Elective</MenuItem>
              <MenuItem disabled={activeCampus === 'FBL'} value='core'>
                Core
              </MenuItem>
            </Select>
          </FormControl>
        </TabPanel>
      </>
    </Paper>
  )
}

function mapStateToProps(state) {
  return {
    data: state.BestTeachingAwardReport
  }
}

const mapDispatchToProps = (dispatch) => ({
  onTabChange: (dataSet) => {
    dispatch(updateBestTeachingAwardParams(dataSet))
  },

  onCampusChange: (dataSet) => {
    dispatch(updateBestTeachingAwardParams(dataSet))
  },
  onCourseTypeChange: (dataSet) => {
    dispatch(updateBestTeachingAwardParams(dataSet))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(StepOne)
